import { SelectOption } from 'global';
import { SaleType } from '../types';

export const defaultCashTerm = '0';

export const saleTypeOptions: SelectOption<SaleType>[] = [
  { label: 'Financing', value: SaleType.Financing },
  { label: 'Cash', value: SaleType.Cash },
];
